/**
 * TPM PUBLIC API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Brand } from './brand';
import { StatusEnum } from './statusEnum';
import { CancellationReason } from './cancellationReason';


/**
 * The appointment behind a management link. ``status`` decides which page the patient sees.
 */
import {ValidatorFn, Validators} from "@angular/forms";

export interface ManagedAppointment { 
    brand: Brand | null;
    appointmentTypeName: string;
    appointmentLength: number;
    appointmentFormatInfo: string;
    appointmentFormatIcon: string;
    appointmentResourceName: string;
    startDate: string;
    status: StatusEnum;
    beforeCancellationPeriod: boolean;
    cancellationPeriodInHours: number;
    cancellationReasons: Array<CancellationReason>;
    sicknessReason: number;
}
export namespace ManagedAppointment {
}

export const ManagedAppointment_brand_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_appointmentTypeName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_appointmentLength_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_appointmentFormatInfo_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_appointmentFormatIcon_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_appointmentResourceName_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_startDate_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_status_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_beforeCancellationPeriod_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_cancellationPeriodInHours_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_cancellationReasons_Validators: ValidatorFn[] =
    [  Validators.required, ];

export const ManagedAppointment_sicknessReason_Validators: ValidatorFn[] =
    [  Validators.required, ];


